<template>
  <!-- app を入れると固定出来るがfooterを固定するメリットがないので入れていない -->
  <v-footer class="print-display-none pa-0" dark padless>
    <v-card class="w-100 flex header-color-cpm-rakuten" flat tile v-if="projectCode === '111'">
      <v-card-title class="pb-0 text-body-2 d-flex justify-center" id="footer-link">
        <span class="ml-2"><br></span>
      </v-card-title>
      <v-card-actions class="justify-center text-body-2"></v-card-actions>
    </v-card>
    <v-card class="w-100 flex header-color-valis" flat tile v-if="projectCode === '301'">
      <v-card-title class="pb-0 text-body-2 d-flex justify-center" id="footer-link">
        <span class="ml-2">
          <a href="https://www.so-netmedia.jp/about/" target="logicad">会社概要</a>
        </span>
        <span class="ml-2">
          <a href="https://www.so-netmedia.jp/sitepolicy/" target="logicad">サイトポリシー</a>
        </span>
        <span class="ml-2">
          <a
            href="https://reg31.smp.ne.jp/regist/is?SMPFORM=rjn-lbnitb-0ba393e552aad6d7bbaa3c0b63ce3c3a"
            target="logicad"
          >お問い合せ</a>
        </span>
        <span class="ml-2">
          <a href="https://www.so-netmedia.jp/privacypolicy/" target="logicad">個人情報保護方針</a>
        </span>
        <span class="ml-2">
          <a href="https://valis-cpx.com/cookie/index.html" target="logicad">データポリシーについて</a>
        </span>
        <span class="ml-2">
          <a href="https://valis-cpx.com/policy.html" target="logicad">システム利用規約</a>
        </span>
      </v-card-title>
      <v-card-actions class="justify-center text-body-2" id="copyright">&copy; {{ new Date().getFullYear() }} SMN Corporation</v-card-actions>
    </v-card>
    <v-card class="flex header-color" flat tile v-else-if="projectCode === '302'">
      <v-card-title class="d-flex justify-center pb-0 text-body-2" id="footer-link">
        <span class="ml-2">
          <a href="https://www.so-netmedia.jp/company/" target="logicad">会社概要</a>
        </span>
        <span class="ml-2">
          <a href="https://www.so-netmedia.jp/sitepolicy/" target="logicad">サイトポリシー</a>
        </span>
        <span class="ml-2">
          <a
            href="https://reg31.smp.ne.jp/regist/is?SMPFORM=rjn-mhqhp-56d0abf3abfa089afe863f9e1da89906"
            target="logicad"
          >お問い合せ</a>
        </span>
        <span class="ml-2">
          <a href="https://www.so-netmedia.jp/compliance/index.html" target="logicad">個人情報保護方針</a>
        </span>
        <span class="ml-2">
          <a href="https://www.so-netmedia.jp/cookie/index.html" target="logicad">データポリシーについて</a>
        </span>
        <span class="ml-1">
          <a href="https://www.logicad.com/policy.html" target="logicad">システム利用規約</a>
        </span>
      </v-card-title>
      <v-card-actions class="justify-center ml-2 text-body-2" id="copyright">&copy; {{ new Date().getFullYear() }} SMN Corporation</v-card-actions>
    </v-card>
  </v-footer>
</template>
<script>
module.exports = {
  data: function() {
    return {}
  },
  computed: {
    projectCode: function() {
      return process.env.ProjectCode
    }
  }
}
</script>
<style scoped>
#copyright {
  color: white;
}
.v-footer {
  flex: none;
}
#footer-link a {
  color: white;
}
.header-color {
  background-color: #4b7001;
}
.header-color-valis {
  background-color: #093493;
}
.header-color-cpm-rakuten {
  background-color: #BF0000;
}

@media print {
  .print-display-none {
    display: none;
  }
}
</style>
